import mixins from 'vue-typed-mixins';

import C勘定科目ListEditModeToggleButton from '@/components/勘定科目/listEdit/button/modeToggle/勘定科目ListEditModeToggleButton.vue';
import C勘定科目ListEditNewButton from '@/components/勘定科目/listEdit/button/new/勘定科目ListEditNewButton.vue';
import C勘定科目ListEditDialog from '@/components/勘定科目/listEdit/dialog/勘定科目ListEditDialog.vue';

import CF計算書Mixin from '@/entries/user/mixins/CF計算書Mixin';
import Plbscf要約表示Mixin from '@/entries/user/mixins/Plbscf要約表示Mixin';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 分析PlbscfMixin from '@/entries/user/mixins/分析PlbscfMixin';
import EventObserverMixin from '@/mixins/EventObserverMixin';

import { PlbscfType } from '@/master/Plbscf';

export default mixins(EventObserverMixin, RoutesMixin, 分析PlbscfMixin, Plbscf要約表示Mixin, CF計算書Mixin).extend({
  name: 'P三表実績',

  components: {
    C勘定科目ListEditNewButton,
    C勘定科目ListEditModeToggleButton,
    C勘定科目ListEditDialog,
  },

  data(): {
    tabTypes: PlbscfType[];
  } {
    return {
      tabTypes: [PlbscfType.貸借対照表, PlbscfType.損益計算書, PlbscfType.CF計算書],
    };
  },

  watch: {
    async isEditing(): Promise<void> {
      if (!this.isEditing) return;
      await this.saveデータ(this.service.getTデータPlbscfs);

      // 再load or 再計算
      if (this.reloadFlag) {
        await this.load();
      } else {
        this.plbscfTypeLists = this.service.calcAndCreatePlbscfTypeList();
        this.initializeFlag();
      }
    },
    eventCount(): void {
      // EventObserverMixin を上書き、一覧での勘定科目並び順変更、削除を想定
      this.load();
    },
  },

  methods: {
    recalculate(): void {
      if (!this.isCF計算書Tab) return;
      this.recalculateByTypeLists(this.plbscfTypeListsOfTabTypes);
    },
  },
});
